export const IDS = {
  BANNER: 'home-top-banner',
} as const;
